
import CookieService from "./CookieService"
import APIService from "./APIService"

export const objectValueSort = (obj) => {
    const ret = {}
    Object.values(obj)
        .sort()
        .forEach(val => {
            const key = Object.keys(obj).find(key => obj[key] === val)
            ret[key] = val
        })
    return ret
}

export const pageReady = (requireEvent=true, requireLogin=true) => {
    if(requireLogin){
        let instanceID = localStorage.getItem("instanceId");
        let token = CookieService.exists("token") ? CookieService.get("token") : ''
        if(instanceID == null || token === '') {
            window.location = '/login'
        }
    }
}

export const isAdmin = () => {
    let instanceID = localStorage.getItem("instanceId");
    APIService.get("AUTH", `${instanceID}/verify/admin`, {'no-slash': 'no-slash'})
    .then(response => {
        if(response.data.exists) {
            localStorage.setItem('adminLogin', true);
            return true;
        } else {
            localStorage.setItem('adminLogin', false);
            return false;
        }
    }).catch(function(error) {
        APIService.error(error, true);
        return false;
    });
}

export const removeEmpty = (obj) => {
    Object.keys(obj).forEach(key => {
        if (Object.keys(obj[key]).length === 0) {
            delete obj[key]
        }
    });
    return obj;
  }

export const transpose = (a) => {
    if (a.length === 0) { return a }
    return a[0].map(function (_, c) { return a.map(function (r) { return r[c]; }); });
}

export const isNumeric = (n) => {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }